<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('prenotazione.dettagli')}}</h1></div>

            <div class="content-full">
                <div v-if="this.reservation">
                    <div class="ordine">
                        {{$t('prenotazione')}} n°: {{this.reservation.id}}
                    </div>

                    <div class="dove border-bottom mb-2">
                      <span class="material-symbols-outlined f40">menu_book</span><br>
                        <b>
                            {{this.reservation.n_persone}} {{$tc('prenotazioni_tavolo.persona',
                            this.reservation.n_persone)}}
                            <br>
                          <span class="text-capitalize">
                            {{moment(this.reservation.data_ora_prenotazione).locale(this.language).format('dddd DD MMMM YYYY')}}
                          </span>
                            {{$t('ore_in_data')}}
                            {{moment(this.reservation.data_ora_prenotazione).locale(this.language).format('HH:mm')}}
                        </b>
                        <br><br>
                        {{$t('prenotazione.riferimento')}}<br>
                        {{$t('nome')}}: {{this.reservation.nome}}<br>
                        {{$t('telefono')}}: {{this.reservation.telefono}}<br>
                        {{$t('email')}}: {{this.reservation.email}}<br><br>
                        {{$t('prenotazione.status')}}:
                        <inc-reservation-status :status="this.reservation.status"/>
                    </div>
                    <div class="border-bottom f16 px-3 py-2" v-if="this.reservation_restaurant_message">
                        <b class="text-gray text-uppercase f14">{{$t('messaggio_locale')}}:</b><br/>
                        <p v-html="this.reservation_restaurant_message"></p>
                    </div>

                  <div class="p-3 text-center" v-if="!['ANNULLATO', 'RIFIUTATO'].includes(this.reservation.status)" style="line-height: 15px;">
                    <div class="bg-gray rounded-lg p-3 f13 text-center">
                      <span class="text-uppercase">{{$t('attenzione_label')}}</span>:<br>
                      <p><i>{{$t('prenotazione.info_annulla')}}</i></p>
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="pi pi-phone f22 mr-2"></i>
                        <b>{{this.locale.telefono}}</b>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container border-top">
                    <div class="row row-sezione">
                        <div class="col-12 text-center">
                            <router-link :to="{name:'reservations.history'}">
                                <button type="button" class="btn btn-default">{{$t('ordine_torna_storico')}}</button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {getReserveDetails} from '../../api/be';

    import IncReservationStatus from "./partials/IncReservationStatus";
    import Modal from "../partials/Modal";
    import ModalCancelReservation from "./partials/ModalCancelReservation";

    export default {
        name: "Details",
        props: ['phone'],
        components: {ModalCancelReservation, Modal, IncReservationStatus},
        data() {
            return {
                reservation: null,

                show_modal: false
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            reservation_restaurant_message: function () {
                try {
                    return this.reservation.messaggio_ristorante.replace(/(?:\r\n|\r|\n)/g, '<br/>');
                } catch (e) {
                    return '';
                }
            },
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getReserveDetails(this.language, {
                    api_key: this.user.api_key,
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    id_prenotazione: this.$route.params.id
                }).then((response) => {
                    this.reservation = response.prenotazione;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
